import $http from '$http'
import {
  lg,
  util
} from 'utils';
import {
  GetERP_OrderById
} from '@api/orderApi.js';

export default {
  methods: {
    //初始化加载页面
    List() {
      let str = this.$route.path
      let index = str.lastIndexOf(":")
      let MenuId = str.substring(index + 1, str.length)

      this.lists = [];
      this.loading2 = true; //拼命加载中显示
      var para = this.getParams();
      let $href = 'api/Order/GetOrderFinanceAuditByPageFor1200'
      if (this.$route.path == '/Order/orderViewList/SchoolOrderView') {
        // Hi-E
        $href = 'api/Order/GetOrderFinanceAuditByPageFor1200'
      } else if (index > 0) {
        // 订单列表（直营Q2） 和订单列表（智趣坞独家）
        para.MenuId = MenuId
        $href = 'api/Order/GetOrderCommonByPage'
      }
      $http.get($href, para).then(res => {
        util.doResult(this, res, () => {
          let {
            StateCode,
            StateMsg,
            Data,
            Cnt
          } = res.data;
          for (var i = 0; i < Data.length; i++) {
            if (Data[i].AreaName !== '') {
              Data[i].AreaName = Data[i].AreaName.split("市")[0] + "市";
            }

            if (Data[i].AreaName == "北京北京市") {
              Data[i].AreaName = "北京市";
            }
            if (Data[i].AreaName == "重庆重庆市") {
              Data[i].AreaName = "重庆市";
            }
            if (Data[i].AreaName == "上海上海市") {
              Data[i].AreaName = "上海市";
            }
            if (Data[i].AreaName == "天津天津市") {
              Data[i].AreaName = "天津市";
            }
          }
          this.totalSize = Cnt;
          this.loading2 = false; //拼命加载中隐藏
          this.lists = Data;
        });
      });
    },
    // 获取套餐列表
    GetParmConfig() {
      var para = {
        Sid: this.Session[0],
        Session: this.Session[1],
        ParmType: 101
      };
      $http.get('api/Common/GetParmConfig', para).then(res => {
        util.doResult(this, res, () => {
          let {
            Data,
            Cnt
          } = res.data;
          this.packageList = Data
        });
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/Order/orderViewList/OrderCommonPage/services.js